import React from 'react';
import styled, { css } from 'styled-components';
import {
  minBreakpointQuery,
  sectionMargins,
  sectionPaddings,
  standardColours,
  fontSize,
} from '../styles';
import { Container, Heading } from './ui';

const StyledContentBlocks = styled.section`
  ${sectionPaddings('50px', '100px')};

  ${({ isContentBlocksImageLinks }) => {
    if (!isContentBlocksImageLinks) {
      return css`
        ${sectionMargins('50px', '100px')};
        background-color: ${standardColours.lightGrey};
      `;
    }
  }}
`;

const StyledHeading = styled(Heading)`
  max-width: 1000px;
`;

const StyledWrapper = styled.div`
  ${minBreakpointQuery.small`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 50px;
  `}

  ${minBreakpointQuery.smedium`
    column-gap: 70px;
  `} 

  ${minBreakpointQuery.medium`
    column-gap: 80px;
  `}  

  ${minBreakpointQuery.mlarge`
    column-gap: 100px;
  `}

  ${minBreakpointQuery.large`
    column-gap: 150px;
  `}

  ${minBreakpointQuery.xlarge`
    column-gap: 220px;
  `}
`;

const StyledText = styled.p`
  margin-top: 30px;
  line-height: 1.75;
  padding-bottom: 20px;
  border-bottom: 1px solid ${standardColours.grey};

  ${minBreakpointQuery.mlarge`
    margin-top: 40px;
    padding-bottom: 30px;
    ${fontSize(18)}
  `}

  ${minBreakpointQuery.large`
    margin-top: 50px;
    padding-bottom: 40px;
  `}
`;

const ContentBlocks = ({ heading, items, isContentBlocksImageLinks }) => (
  <StyledContentBlocks isContentBlocksImageLinks={isContentBlocksImageLinks}>
    <Container>
      <StyledHeading>{heading}</StyledHeading>
      <StyledWrapper>
        {items.map(({ text }, id) => (
          <StyledText key={id}>{text}</StyledText>
        ))}
      </StyledWrapper>
    </Container>
  </StyledContentBlocks>
);

export default ContentBlocks;
